<template>
    <el-dialog
        :visible="visible"
        :modal-append-to-body="false"
        :class="['payment-detail-dialog', 'ah-detail-dialog']"
        top=""
        append-to-body
        :before-close="handleBeforeClose"
        :lock-scroll="false"
        ref="paymentDetailDialig"
    >
        <template slot="title">
            <el-row>
                <el-col :span="24">
                    <span>
                        請款單 <span class="sno"># {{ form.payoo }}</span>
                    </span>
                </el-col>
            </el-row>
        </template>
        <!-- 錯誤刪除 -->
        <div class="detail-row error" v-if="form.typ !== 6 && !form.deleted && form.audits && form.audits.length == 0">
            <el-row>
                <el-col :span="18"> 這筆請款單有些異常狀況，請作廢再重建。 </el-col>
                <el-col :span="6" style="text-align: right">
                    <el-button type="danger" plain size="small" @click="deletePayment">作廢</el-button>
                </el-col>
            </el-row>
        </div>
        <!-- 進度 -->
        <div class="detail-row progress" style="">
            <ah-audit-progress
                type="payment"
                :pm-list="form.pmList"
                :pa-info="{ name: form.projectAuditorName, sno: form.projectAuditor }"
                :data="form.audits"
                :statusCode="form.sigN_STS"
                size="large"
                :stfNam="this.form.creator"
                :createDate="this.form.crT_DAT"
            ></ah-audit-progress>
        </div>
        <div class="dialog-section">
            <el-form ref="form" :rules="rules" :model="simpleInfo">
                <div class="detail-block" style="margin-bottom: 5px">
                    <div style="display: flex; justify-content: space-between">
                        <!-- 請款單類型 -->
                        <div
                            :class="{
                                'payment-type': true,
                                project: form.typ === 2 || form.typ === 3 || form.typ === 4,
                            }"
                        >
                            <!-- 類型 -->
                            <span class="type-label">
                                {{ getPaymentType(form.typ) }}
                                <span v-if="form.tranServiceFeeStatement">[勞務單轉送]</span>
                            </span>
                            <!-- 經常性資訊 -->
                            <div v-if="form.typ === 4" class="project-label">
                                <span class="name">{{ form.ofeN_ITEM_NAM }}</span>
                            </div>
                        </div>
                    </div>
                    <div style="margin: 10px 0 10px 0">
                        <div style="margin-bottom: 8px">
                            <div style="font-size: 15pt; margin-top: 5px">
                                <div v-if="isEditNamMode" class="edit-form">
                                    <div>
                                        <el-button size="mini" :loading="isLoading" @click="onEndEditNam"> <i class="el-icon-close"></i> 取消 </el-button>
                                        <el-button size="mini" :loading="isLoading" type="primary" @click="onSubmitModifyNam"> <i class="el-icon-check"></i> 儲存 </el-button>
                                    </div>
                                    <el-form-item prop="nam" style="margin-top: 10px">
                                        <el-input v-model="simpleInfo.nam" class="nam-edit-input" :maxlength="100" :show-word-limit="true" size="small" />
                                    </el-form-item>
                                    <el-form-item prop="modifY_REASON" :rules="form.naM_MODIFY_REASON || simpleInfo.nam !== form.nam ? rules.modifY_REASON : []" label="摘要編輯原因">
                                        <el-input class="nam-edit-input" v-model="simpleInfo.modifY_REASON" :maxlength="50" :show-word-limit="true" size="small" />
                                    </el-form-item>
                                </div>
                                <div v-else class="edit-form">
                                    <div>
                                        <div class="nam-block">
                                            <div style="font-weight: bold">
                                                <span v-if="form.canceled">[已註銷]</span>
                                                <span v-if="form.deleted">[已作廢]</span>
                                                {{ form.nam }}
                                            </div>
                                            <div>
                                                <el-dropdown @command="onMoreDropdownClick">
                                                    <el-button size="mini">
                                                        <i class="el-icon-more"></i>
                                                    </el-button>
                                                    <el-dropdown-menu slot="dropdown">
                                                        <el-dropdown-item :disabled="form.deleted" command="edit-nam" icon="el-icon-edit">編輯摘要</el-dropdown-item>
                                                        <el-dropdown-item command="duplicate" icon="el-icon-document-copy">複製請款單</el-dropdown-item>
                                                        <el-tooltip :content="modifyProjectDisableMsg" :disabled="!modifyProjectDisableMsg" placement="top">
                                                            <div style="width: 100%">
                                                                <el-dropdown-item command="modifyProject" icon="el-icon-folder-opened" :disabled="!!modifyProjectDisableMsg">變更所屬專案</el-dropdown-item>
                                                            </div>
                                                        </el-tooltip>
                                                    </el-dropdown-menu>
                                                </el-dropdown>
                                                <!-- <el-button
                                                    v-if="isEditable"
                                                    size="mini"
                                                    plain
                                                    @click="onEditNam"
                                                >
                                                    編輯
                                                </el-button> -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="form.naM_MODIFY_REASON">
                                    <span class="sno" style="font-size: 9pt; color: #888"> 編輯原因：{{ form.naM_MODIFY_REASON }} </span>
                                </div>
                                <div v-if="form.simplE_UPD_USR && form.simplE_UPD_DAT">
                                    <span class="sno" style="font-size: 9pt; color: #888">
                                        ( {{ form.simplE_UPD_USR }} 於
                                        {{ form.simplE_UPD_DAT | dateFormater("YYYY/MM/dd hh:mm") }}
                                        編輯 )
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 支出項目 -->
                <StateItemInlineEditor
                    v-if="isStateItemInlineEditorShow"
                    type="payment"
                    size="small"
                    :sno="form.sno"
                    :receipt-accno="form.accno"
                    :itemSno="form.iteM_SNO"
                    :enable="isAuthOne(['A03'])"
                    :allow-empty="form.deleted"
                    @changed="
                        isStatementChanged = true;
                        reload();
                    "
                    style="margin-bottom: 15px"
                />

                <ahProjectDetailView
                    v-if="form.typ === 2 || form.typ === 3 || (form.typ === 6 && selectedProject.name)"
                    :selectedProject="selectedProject"
                    :form="form"
                    :isProjectBudgetVisible="isProjectBudgetVisible"
                    :isProjectOpenable="isProjectOpenable"
                    style="margin: 20px 0 20px 0"
                    source="payment"
                    @open="openProjectDetail"
                />

                <el-row :gutter="40" style="padding: 10px 0 20px 0">
                    <el-col :sm="14">
                        <table class="ah-basic-data-table" cellspacing="0" cellpadding="0">
                            <tr>
                                <th>請款單日期</th>
                                <td>
                                    <div v-if="isEditDateMode" class="edit-dat-set">
                                        <el-form-item prop="dat">
                                            <el-date-picker
                                                v-model="simpleInfo.dat"
                                                value-format="timestamp"
                                                type="date"
                                                size="small"
                                                placeholder="選擇日期"
                                                :loading="isLoading"
                                                :picker-options="expireTimeOption"
                                                :clearable="false"
                                                style="max-width: 140px"
                                            >
                                            </el-date-picker>
                                        </el-form-item>
                                        <span class="actions" style="margin-top: 5px">
                                            <el-button size="mini" :loading="isLoading" type="danger" @click="onEndEditDate" icon="el-icon-close"></el-button>
                                            <el-button size="mini" :loading="isLoading" type="success" @click="onSubmitModifyDate" icon="el-icon-check"></el-button>
                                        </span>
                                    </div>
                                    <span v-else>
                                        {{ form.dat | dateFormater("YYYY-MM-dd") }}
                                        <span>
                                            <el-button
                                                v-if="isEditable && !isEditDateMode"
                                                size="mini"
                                                plain
                                                @click="onEditDate"
                                                icon="el-icon-edit"
                                                style="padding: 3px 7px; margin-left: 5px"
                                                type="text"
                                            ></el-button>
                                        </span>
                                    </span>
                                    <div v-if="form.daT_UPD_USR && form.daT_UPD_DAT" style="font-size: 9pt; color: #888; margin-bottom: 10px">
                                        ( {{ form.daT_UPD_USR }} 於
                                        {{ form.daT_UPD_DAT | dateFormater("YYYY/MM/dd hh:mm") }}
                                        編輯 )
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>狀態</th>
                                <td>
                                    <payment-status-label :status-num="form.sigN_STS" v-if="form.sno" :isTempSaved="isTempSaved" class="dialog-status"></payment-status-label>
                                    <el-tag v-if="form.toBeAddFile" style="line-height: 24px; height: 26px; vertical-align: top">待補單據</el-tag>
                                </td>
                            </tr>

                            <tr>
                                <th>申請人</th>
                                <td>
                                    {{ form.creator }}
                                </td>
                            </tr>
                            <tr>
                                <th style="">申請日期</th>
                                <td>
                                    {{ form.crT_DAT | dateFormater("YYYY-MM-dd") }}
                                </td>
                            </tr>
                            <tr v-if="form.typ !== 6">
                                <th>付款對象</th>
                                <td>
                                    <template v-if="form.paY_TO != 1 && form.typ != 5">
                                        <span class="pay-to-type-label">{{ payToTitle }}</span>
                                        <span>{{ protectedName(getPayToName) }}</span>
                                    </template>
                                    <template v-else>
                                        <div>
                                            <span>{{ getPayToName }}</span>
                                            <br />
                                            <template v-if="form.payIdNumber">
                                                <span style="color: #aaa">
                                                    {{ protectedInfo(form.payIdNumber, "get", 4, true) }}
                                                </span>
                                                <br />
                                            </template>
                                            <span v-if="form.payEmail" style="color: #aaa">
                                                {{ form.payEmail }}
                                            </span>
                                        </div>
                                    </template>
                                </td>
                            </tr>
                        </table>
                    </el-col>
                    <el-col :sm="10">
                        <div class="info-amts">
                            <table class="ah-basic-data-table" cellspacing="0" cellpadding="0" style="width: 100%">
                                <tr v-if="form.taX_AMT">
                                    <th>勞務稅</th>
                                    <td class="right">
                                        <Money :v="taX_AMT_NTD || 0" round />
                                        <span class="cny">TWD</span>
                                    </td>
                                </tr>
                                <tr v-if="form.geN2_AMT">
                                    <th>二代健保</th>
                                    <td class="right">
                                        <Money :v="geN2_AMT_NTD || 0" round />
                                        <span class="cny">TWD</span>
                                    </td>
                                </tr>
                                <tr class="strong">
                                    <th>實付金額</th>
                                    <td class="right">
                                        <Money :v="form.amt - form.taX_AMT - form.geN2_AMT" :precision="form.cny === 'TWD' ? null : 4" />
                                        <span class="cny">{{ form.cny }}</span>
                                        <ahTip v-if="form.cny != 'TWD'">
                                            <div>
                                                約當台幣：
                                                <Money
                                                    :v="form.paY_CNYRAT ? (form.amt - form.taX_AMT - form.geN2_AMT) * form.paY_CNYRAT : (form.amt - form.taX_AMT - form.geN2_AMT) * getCnyRat(form.cny)"
                                                    round
                                                />
                                            </div>
                                            <div style="opacity: 0.8; font-size: 10pt; margin-top: 5px">匯率：{{ form.paY_CNYRAT ? form.paY_CNYRAT : getCnyRat(form.cny) + " (即時)" }}</div>
                                        </ahTip>
                                    </td>
                                </tr>
                                <tr>
                                    <th>請款金額</th>
                                    <td class="right">
                                        <Money :v="form.amt" style="font-size: 15pt" :precision="form.cny === 'TWD' ? null : 4" />
                                        <span class="cny">{{ form.cny }}</span>
                                        <ahTip v-if="form.cny != 'TWD'">
                                            <div>
                                                約當台幣：
                                                <Money :v="form.paY_CNYRAT ? form.amt * form.paY_CNYRAT : form.amt * getCnyRat(form.cny)" round />
                                            </div>
                                            <div style="opacity: 0.8; font-size: 10pt; margin-top: 5px">匯率：{{ form.paY_CNYRAT ? form.paY_CNYRAT : getCnyRat(form.cny) + " (即時)" }}</div>
                                        </ahTip>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <ServiceFeeStatementDetailView
            v-if="form.paY_TO == 3 && (isPayed('H01') || this.form.serviceFeeStatement.length > 0)"
            :service-fee-statement-list="form.serviceFeeStatement"
            :payment-sno="form.sno"
            :payment="form"
            :disabled="form.deleted"
            @submit="onServiceFeeStatementSubmit"
        />
        <div class="dialog-section">
            <div class="dialog-section-title">
                <span class="left-cell">
                    <span>檢附單據 </span>
                    <span v-if="!form.files || form.files.length === 0">(無)</span>
                    <span v-if="form.files && form.files.length > 0">({{ form.files.length }})</span>
                </span>
                <span class="right-cell">
                    <template v-if="isShowReceiptEditBtn">
                        <template v-if="action !== 'upload-receipt'">
                            <el-button size="small" @click="handleAddReceiptClick" icon="el-icon-document-add" style="margin-right: 5px;">新增單據</el-button>
                            <el-button size="small" @click="action = 'upload-receipt'" icon="el-icon-edit">編輯</el-button>
                        </template>
                        <template v-else-if="action === 'upload-receipt'">
                            <el-button size="small" @click="handleCancelReceiptBtnClick">結束編輯</el-button>
                        </template>
                    </template>
                    <template v-else>
                        <ah-tip>
                            <div>您沒有權限在此請款單上傳單據。</div>
                            <div style="margin-top: 5px; font-size: 9pt; font-weight: normal;">（需為申請人、或有付款相關權限的財務人員）</div>
                        </ah-tip>
                    </template>
                </span>
            </div>
            <table class="ah-basic-data-table" cellspacing="0" cellpadding="0" v-if="form.files && form.files.length > 0">
                <tr class="strong">
                    <th>單據總計</th>
                    <td>
                        <div><Money :v="filesTotalAmt" /> {{ form.cny }}</div>
                    </td>
                </tr>
            </table>

            <el-form :model="form" label-position="left" label-width="135px" v-if="action == 'upload-receipt'">
                <el-form-item label="待補單據標示">
                    <el-checkbox v-model="form.toBeAddFile" @change="onReceiptUploadInputSave"></el-checkbox>
                </el-form-item>
            </el-form>
            <ReceiptUploadInput
                ref="receiptUploadInput"
                v-model="form.files"
                :cny="form.cny"
                :vdrSno="form.paY_TO === 2 && form.vdR_SNO"
                :disabled="action != 'upload-receipt'"
                @declareStatusChange="onDeclareStatusChange"
                @onSave="onReceiptUploadInputSave"
            />
            <div v-if="action != 'upload-receipt' && form && form.files && form.files.length > 1" style="margin-top: 10px">
                <el-button size="small" @click="handleAddReceiptClick" icon="el-icon-document-add" style="margin-right: 5px;">新增單據</el-button>
            </div>
            <div v-if="action == 'upload-receipt'" style="margin: 15px 0 0 0; text-align: center">
                <el-button @click="handleCancelReceiptBtnClick">結束編輯</el-button>
            </div>
        </div>
        <!-- 工作內容 -->
        <div class="dialog-section" v-if="form.paY_TO == 3">
            <div class="dialog-section-title">勞務工作內容</div>
            <table class="ah-basic-data-table" cellspacing="0" cellpadding="0">
                <tr>
                    <th>勞務所得類別</th>
                    <td>{{ getServiceTypeTxt(form.serviceType) }}</td>
                </tr>
                <tr v-if="form.serviceSubType || form.otherServiceType">
                    <template>
                        <th>執行業別代號</th>
                        <td v-if="form.serviceType === 1 || form.serviceType === 2">{{ getServiceSubTypeTxt(form.serviceSubType) }}</td>
                        <td v-else-if="form.serviceType === 0">{{ form.otherServiceType }}</td>
                    </template>
                </tr>
                <tr>
                    <th>工作內容</th>
                    <td>
                        <div v-if="form.oS_MEM && form.oS_MEM != ''" style="white-space: pre">{{ form.oS_MEM }}</div>
                        <div v-else style="opacity: 0.4">（無）</div>
                    </td>
                </tr>
            </table>
        </div>
        <!-- 付款資訊 -->
        <div class="dialog-section">
            <div class="dialog-section-title">付款資訊</div>
            <el-row :gutter="40">
                <el-col :sm="12">
                    <table class="ah-basic-data-table" cellspacing="0" cellpadding="0">
                        <tr v-if="form.typ === 5">
                            <th>收款人</th>
                            <td>{{ form.paY_NAM }}</td>
                        </tr>
                        <tr v-if="form.typ === 5">
                            <th>國家</th>
                            <td>{{ form.paY_COUNRTY }}</td>
                        </tr>
                        <tr v-if="form.typ !== 5">
                            <th>預計付款方式</th>
                            <td>
                                <span v-if="form.useR_PAY_WAY === 1">
                                    <span>零用現金</span>
                                    <template v-if="(form.sigN_STS == 5 && form.a02_ISTEMP) || form.sigN_STS === 2 || form.sigN_STS === 3">
                                        <span v-if="form.paY_WAY === 3" class="pay-way-change-hint">（已改為銀行提現付款）</span>
                                    </template>
                                </span>
                                <span v-else-if="form.useR_PAY_WAY === 2">
                                    <span>銀行轉帳</span>
                                    <template v-if="(form.sigN_STS == 5 && form.a02_ISTEMP) || form.sigN_STS === 2 || form.sigN_STS === 3">
                                        <span v-if="form.paY_WAY === 1" class="pay-way-change-hint">（已改為零用現金付款）</span>
                                        <span v-if="form.paY_WAY === 3" class="pay-way-change-hint">（已改為銀行提現付款）</span>
                                    </template>
                                </span>
                                <span v-else-if="form.useR_PAY_WAY === 3">
                                    <span>銀行提現</span>
                                </span>
                                <span v-else>未知的付款方式</span>
                                <span v-if="form.abd == 1 && form.useR_PAY_WAY === 2">
                                    (境外 -
                                    <span v-if="form.abD_TYP == 2">民間</span>
                                    <span v-if="form.abD_TYP == 1">公營事業</span>
                                    <span v-if="form.abD_TYP == 0">政府</span>)</span
                                >
                            </td>
                        </tr>
                        <tr>
                            <th>
                                預計付款日
                                <ahTip v-if="form.sigN_STS == 5">收支日曆依此顯示</ahTip>
                            </th>
                            <td>
                                <div v-if="!editPdatEnable">
                                    <span>{{ form.pdat | dateFormater("YYYY-MM-dd") }}</span>
                                    <el-button
                                        v-if="form.sigN_STS == 5 && isAuth('A02') && !form.deleted"
                                        size="mini"
                                        plain
                                        @click="handleEditPdatBtnClick"
                                        icon="el-icon-edit"
                                        style="padding: 3px 7px; margin-left: 10px"
                                        type="text"
                                    ></el-button>
                                    <div style="display: inline-block; margin: 2px 0 5px 0; color: #888; font-size: 9.5pt; font-weight: normal" v-if="form.pdaY_MOD_USER">
                                        ( {{ form.pdaY_MOD_USER }} 於
                                        {{ form.pdaY_MOD_DAT | dateFormater("YYYY/MM/dd hh:mm") }}
                                        編輯 )
                                    </div>
                                </div>
                                <div v-if="editPdatEnable" class="edit-dat-set" style="margin-bottom: 10px">
                                    <el-date-picker
                                        ref="editPdatDatePicker"
                                        v-model="editPdatDate"
                                        type="date"
                                        value-format="timestamp"
                                        placeholder="選擇新日期"
                                        style="margin-bottom: 5px; max-width: 140px"
                                        size="small"
                                        :clearable="false"
                                    ></el-date-picker>
                                    <div class="actions">
                                        <el-button size="mini" type="danger" icon="el-icon-close" @click="handleEditPdatCancelBtnClick"></el-button>
                                        <el-button size="mini" type="success" icon="el-icon-check" @click="handleEditPdatSubmitBtnClick"></el-button>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr v-if="form.useR_PAY_WAY == 2 && form.typ !== 5 && form.typ !== 6">
                            <th>收款戶名</th>
                            <td>
                                <div v-if="form.vdR_BNK_TPC == ''" style="opacity: 0.4; font-weight: normal">(無)</div>
                                <div v-else>
                                    {{ protectedName(form.vdR_BNK_TPC) }}
                                </div>
                            </td>
                        </tr>
                        <tr v-if="form.useR_PAY_WAY == 2 && form.typ !== 5 && form.typ !== 6">
                            <th>收款銀行</th>
                            <td>
                                <div v-if="form.abroadBankName">{{ form.abroadBankName }}</div>
                                <div v-else-if="form.bankName">
                                    <div v-if="form.vdR_BNK_BOO == ''" style="opacity: 0.4; font-weight: normal">(無)</div>
                                    <div v-else>
                                        <div>{{ form.bankName }} ({{ form.vdR_BNK_BOO }})</div>
                                        <div v-if="form.vdR_BNK_DOO">分行代碼：{{ form.vdR_BNK_DOO }}</div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr v-if="form.useR_PAY_WAY == 2 && form.typ !== 5 && form.typ !== 6">
                            <th>收款帳號</th>
                            <td>
                                <div v-if="form.vdR_BNK_ACC == ''" style="opacity: 0.4; font-weight: normal">(無)</div>
                                <div v-else>
                                    {{ protectedNumber(form.vdR_BNK_ACC) }}
                                </div>
                            </td>
                        </tr>
                        <tr v-if="form.useR_PAY_WAY == 2 && form.typ !== 5 && form.typ !== 6">
                            <th>備註、其他資訊</th>
                            <td>
                                {{ form.vdR_BNK_NOTE }}
                            </td>
                        </tr>
                    </table>
                </el-col>
                <el-col :sm="12">
                    <div v-if="!(form.paY_TO == 1 && form.useR_PAY_WAY == 2) && form.typ !== 5 && form.typ !== 6">
                        <table class="ah-basic-data-table" cellspacing="0" cellpadding="0">
                            <tr>
                                <th>聯絡人</th>
                                <td>
                                    {{ protectedName(form.vdR_NAM) }}
                                </td>
                            </tr>
                            <tr>
                                <th>聯絡電話</th>
                                <td>
                                    {{ form.vdR_TEL ? protectedNumber(form.vdR_TEL) : "(無)" }}
                                </td>
                            </tr>
                            <tr>
                                <th>聯絡信箱</th>
                                <td>
                                    {{ form.vdR_EML ? protectedEmail(form.vdR_EML) : "(無)" }}
                                </td>
                            </tr>
                        </table>
                    </div>
                </el-col>
            </el-row>
        </div>
        <!-- 退件說明 -->
        <div class="dialog-section reject" v-if="form.sigN_STS === 4">
            <div class="dialog-section-title">退件</div>
            <table class="ah-basic-data-table" cellspacing="0" cellpadding="0">
                <tr v-if="rejectAuditingAudit">
                    <th>退件原因</th>
                    <td style="color: red">{{ rejectAuditingAudit.rsn }}</td>
                </tr>
                <tr v-if="rejectAuditingAudit">
                    <th>退件人</th>
                    <td>{{ rejectAuditingAudit.stF_NAM }} ({{ rejectAuditingAudit.sdat | dateFormater("YYYY-MM-dd") }})</td>
                </tr>
            </table>
        </div>
        <!-- 付款明細 -->
        <div class="dialog-section paid" v-if="((form.sigN_STS == 5 && form.a02_ISTEMP) || form.sigN_STS == 2 || form.sigN_STS == 3) && action == 'view'">
            <div class="dialog-section-title">
                <div class="left-cell">
                    <span
                        >付款明細
                        <el-button v-if="isShowPayEditBtn && !isEditingFinishedPayData" class="edit-btn orange" size="mini" @click="onEditingFinishedPayData"> 編輯 </el-button>
                    </span>
                    <span v-if="form.sigN_STS == 5 && form.a02_ISTEMP">（暫存）</span>
                </div>
            </div>
            <el-row :gutter="40">
                <el-col :sm="12">
                    <table class="ah-basic-data-table" cellspacing="0" cellpadding="0">
                        <tr>
                            <th>實際付款方式</th>
                            <td>
                                <span v-if="form.paY_WAY === 1">零用現金</span>
                                <span v-else-if="form.paY_WAY === 2">銀行轉帳</span>
                                <span v-else-if="form.paY_WAY === 3">銀行提現</span>
                                <span v-else>未知({{ form.paY_WAY }})</span>
                            </td>
                        </tr>
                        <tr>
                            <th>實付金額</th>
                            <td>
                                <Money :v="form.amt - form.taX_AMT - form.geN2_AMT" />
                                <span class="cny">{{ form.cny }}</span>
                            </td>
                        </tr>
                        <tr v-if="form.cny !== 'TWD'">
                            <th>轉出當下匯率</th>
                            <td>{{ form.paY_CNYRAT }}</td>
                        </tr>
                        <tr v-if="form.cny !== 'TWD'">
                            <th>約當台幣</th>
                            <td>
                                <Money :v="(form.amt - form.taX_AMT - form.geN2_AMT) * form.paY_CNYRAT" round />
                                TWD
                            </td>
                        </tr>
                        <tr>
                            <th>
                                實際付款日期
                                <ahTip v-if="form.sigN_STS == 2 || form.sigN_STS == 3"> 收支日曆依此顯示 </ahTip>
                            </th>
                            <td>
                                <div v-if="!isEditingFinishedPayData">
                                    <span>{{ form.paY_DAT | dateFormater("YYYY-MM-dd") }}</span>
                                    <span
                                        v-if="form.paY_DAT > new Date().getTime()"
                                        style="margin-left: 10px; font-size: 10pt; color: #f18d13; padding: 2px 7px; border: 1px solid #f18d13; border-radius: 4px"
                                    >
                                        預約付款
                                    </span>
                                </div>
                                <div v-else>
                                    <el-date-picker v-model="form.paY_DAT" value-format="timestamp" type="date" placeholder="選擇日期" style="width: 200px; margin-bottom: 5px"> </el-date-picker>
                                </div>
                            </td>
                        </tr>
                        <tr v-if="form.paY_WAY !== 1">
                            <th>轉出帳戶</th>
                            <td>
                                <div v-if="!isEditingFinishedPayData">
                                    {{ getBankAccountNameBySno(form.paY_BNK_SNO) }}
                                </div>
                                <div v-else>
                                    <ah-el-select-bank-account v-model="form.paY_BNK_SNO" document-type="payment" :cny="form.cny" hide-borrower> </ah-el-select-bank-account>
                                </div>
                            </td>
                        </tr>
                        <tr v-if="isEditingFinishedPayData">
                            <th></th>
                            <td>
                                <div style="margin-top: 10px">
                                    <el-button size="small" :disabled="isUpdatingFinishPayment" @click="reload" icon="el-icon-close">取消</el-button>
                                    <el-button size="small" type="primary" :loading="isUpdatingFinishPayment" @click="submitPayChange" icon="el-icon-check">儲存</el-button>
                                </div>
                            </td>
                        </tr>
                    </table>
                </el-col>
                <el-col :sm="12">
                    <table class="ah-basic-data-table" cellspacing="0" cellpadding="0" v-if="getAuditData">
                        <tr v-if="form.useR_PAY_WAY == 2 && form.typ !== 5">
                            <th>收款戶名</th>
                            <td>
                                <div v-if="form.vdR_BNK_TPC == ''" style="opacity: 0.4; font-weight: normal">(無)</div>
                                <div v-else>
                                    {{ protectedName(form.vdR_BNK_TPC) }}
                                </div>
                            </td>
                        </tr>
                        <tr v-if="getAuditData.stF_NAM">
                            <th>填寫人</th>
                            <td>{{ getAuditData.stF_NAM }}</td>
                        </tr>
                        <tr v-if="getAuditData.sdat">
                            <th>填寫日期</th>
                            <td>
                                <span>
                                    {{ getAuditData.sdat | dateFormater("YYYY-MM-dd") }}
                                </span>
                            </td>
                        </tr>
                    </table>
                </el-col>
            </el-row>
        </div>
        <!-- 委外勞務、二代健保：有勞稅金＆待付款以暫存(5, a02_ISTEMP)、待確認付款(2)、完成(3)才顯示 -->
        <div class="dialog-section paid" v-if="(form.taX_AMT || form.geN2_AMT) && (form.sigN_STS === 2 || form.sigN_STS === 3 || (form.sigN_STS == 5 && form.a02_ISTEMP))">
            <el-row :gutter="40">
                <el-col :sm="12">
                    <div v-if="form.taX_CHK">
                        <div class="dialog-section-title" style="font-weight: bold; margin-bottom: 15px">
                            <span>代扣所得稅</span>
                            <el-button v-if="isShowTaxEditBtn && !isEditingFinishedTaxData" class="edit-btn orange" size="mini" style="margin-left: 10px" @click="onEditFinishedTaxData">
                                編輯
                            </el-button>
                        </div>
                        <table class="ah-basic-data-table" cellspacing="0" cellpadding="0">
                            <tr>
                                <th>金額</th>
                                <td>
                                    <Money :v="taX_AMT_NTD" round />
                                    <span class="cny">TWD</span>
                                    <span> ({{ Math.round((form.taX_AMT / form.amt) * 10000) / 100 }}%)</span>
                                </td>
                            </tr>
                            <tr>
                                <th>付款日期</th>
                                <td>
                                    <div v-if="!isEditingFinishedTaxData">
                                        {{ form.taX_PAY_DAT | dateFormater("YYYY-MM-dd") }}
                                    </div>
                                    <div v-else>
                                        <el-date-picker v-model="form.taX_PAY_DAT" value-format="timestamp" type="date" placeholder="選擇日期"> </el-date-picker>
                                        <div v-if="isTaxPayDateInvalid" class="date-warning">
                                            <i class="el-icon-warning-outline"></i>
                                            應於實際付款日之後
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>付款帳戶</th>
                                <td>
                                    <div v-if="!isEditingFinishedTaxData">
                                        {{ getBankAccountNameBySno(form.taX_BNK_SNO) }}
                                    </div>
                                    <div v-else>
                                        <ah-el-select-bank-account v-model="form.taX_BNK_SNO" document-type="payment" cny="TWD" hide-borrower allow-cash> </ah-el-select-bank-account>
                                    </div>
                                </td>
                            </tr>
                            <tr v-if="isEditingFinishedTaxData">
                                <th></th>
                                <td>
                                    <div style="margin-top: 5px">
                                        <el-button size="small" :disabled="isUpdatingFinishPayment" @click="reload">取消</el-button>
                                        <el-button size="small" type="primary" :loading="isUpdatingFinishPayment" @click="submitPayChange"> 儲存 </el-button>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>
                </el-col>
                <el-col :sm="12">
                    <div v-if="form.geN2_AMT">
                        <div class="dialog-section-title" style="font-weight: bold; margin-bottom: 15px">
                            <span>代扣二代健保</span>
                            <el-button v-if="isShowGen2EditBtn && !isEditingFinishedGen2Data" class="edit-btn orange" size="mini" style="margin-left: 10px" @click="onEditFinishedGen2Data">
                                編輯
                            </el-button>
                        </div>
                        <table class="ah-basic-data-table" cellspacing="0" cellpadding="0">
                            <tr>
                                <th>金額</th>
                                <td>
                                    <Money :v="geN2_AMT_NTD" round />
                                    <span class="cny">TWD</span>
                                    <span> ({{ Math.round((form.geN2_AMT / form.amt) * 10000) / 100 }}%)</span>
                                </td>
                            </tr>
                            <tr>
                                <th>付款日期</th>
                                <td>
                                    <div v-if="!isEditingFinishedGen2Data">
                                        {{ form.geN2_PAY_DAT | dateFormater("YYYY-MM-dd") }}
                                    </div>
                                    <div v-else>
                                        <el-date-picker v-model="form.geN2_PAY_DAT" value-format="timestamp" type="date" placeholder="選擇日期"> </el-date-picker>
                                        <div v-if="isGen2PayDateInvalid" class="date-warning">
                                            <i class="el-icon-warning-outline"></i>
                                            應於實際付款日之後
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>付款帳戶</th>
                                <td>
                                    <div v-if="!isEditingFinishedGen2Data">
                                        {{ getBankAccountNameBySno(form.geN2_BNK_SNO) }}
                                    </div>
                                    <div v-else>
                                        <ah-el-select-bank-account v-model="form.geN2_BNK_SNO" document-type="payment" cny="TWD" hide-borrower allow-cash> </ah-el-select-bank-account>
                                    </div>
                                </td>
                            </tr>
                            <tr v-if="isEditingFinishedGen2Data">
                                <th></th>
                                <td>
                                    <div style="margin-top: 5px">
                                        <el-button size="small" :disabled="isUpdatingFinishPayment" @click="reload">取消</el-button>
                                        <el-button size="small" type="primary" :loading="isUpdatingFinishPayment" @click="submitPayChange"> 儲存 </el-button>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>
                </el-col>
            </el-row>
        </div>
        <div class="dialog-section checked" v-if="form.sigN_STS == 3 && auditPass">
            <div class="dialog-section-title">已確認付款</div>
            <table class="ah-basic-data-table" cellspacing="0" cellpadding="0">
                <tr>
                    <th>確認人</th>
                    <td>{{ auditPass.stF_NAM }}</td>
                </tr>
                <tr>
                    <th>確認時間</th>
                    <td>{{ auditPass.sdat | dateFormater("YYYY-MM-dd") }}</td>
                </tr>
            </table>
        </div>
        <AccountingInfoBlock
            v-if="form.sigN_STS === 5 || form.sigN_STS === 2 || form.sigN_STS === 3"
            :sno="form.sno"
            :qty="form.voU_COUNT"
            :status="form.vocherStatus"
            :queryType="2"
            :voucher-status-updater="form.voucherStatusUpdateName"
            :voucher-status-update-date="form.voucherStatusUpdateDate"
            :accno="form.accno"
            :accnam="form.accnam"
            :clearanceAccno="form.clearanceAccno"
            :clearanceAccnoNam="form.clearanceAccnoNam"
            @refresh="() => reload()"
        />
        <div class="dialog-section cancel" v-if="form.canceled == true">
            <div class="dialog-section-title">已註銷</div>
            <table class="ah-basic-data-table" cellspacing="0" cellpadding="0">
                <tr>
                    <th>註銷人</th>
                    <td>{{ form.cancelUser }}</td>
                </tr>
                <tr>
                    <th>註銷時間</th>
                    <td>{{ form.cancelDate | dateFormater("YYYY-MM-dd") }}</td>
                </tr>
            </table>
        </div>
        <!-- 退件操作 -->
        <transition enter-active-class="animate__animated animate__fadeIn ">
            <payment-reject :show="action == 'reject'" @canceled="action = 'view'" @submitted="handleRejectSubmitted" :sno="form.sno" :audit="nowAuditingAudit" />
        </transition>
        <!-- 付款 -->
        <transition enter-active-class="animate__animated animate__fadeIn ">
            <payment-paid
                ref="paymentPaid"
                :show="action == 'paid'"
                :payment="form"
                :curr-audit="nowAuditingAudit"
                :pay-to-list="payToList"
                @submitted="handlePaidSubmitted"
                @save="handlePaidSave"
                @canceled="handlePaidCanceled"
            />
        </transition>
        <!-- Footer 功能按鈕 -->
        <div class="detail-row footer" v-if="action == 'view' && form.sno != 0">
            <div class="footer-action-buttons">
                <div class="left">
                    <el-button type="" plain @click="handleBeforeClose" icon="el-icon-arrow-left">返回列表</el-button>
                    <el-button v-if="isShowPrintBtn" type="" @click="printPayment" icon="el-icon-printer">列印請款單</el-button>
                    <el-popover placement="top" title="作廢" width="220" :close-delay="0" trigger="hover" :content="hasDeclaredReceipts ? '檢附單據中含有已申報的單據，無法作廢。' : '作廢此請款單。'">
                        <span slot="reference">
                            <el-button v-if="isShowDeleteBtn" type="" plain @click="deletePayment" :disabled="hasDeclaredReceipts" icon="el-icon-delete">作廢</el-button>
                        </span>
                    </el-popover>
                </div>
                <div class="right" v-if="!form.deleted && !form.canceled">
                    <template v-if="isShowSelfReturnBtn">
                        <el-popover placement="top" width="250" :close-delay="0" trigger="hover">
                            <div style="padding: 10px">
                                <div style="font-size: 12pt; font-weight: bold; margin-bottom: 12px">退件</div>
                                <div v-if="hasDeclaredReceipts">
                                    <div>檢附單據中含有已申報的單據，無法退件。</div>
                                    <div style="margin-top: 12px">請聯繫營業稅申報人員做處理。</div>
                                </div>
                                <div v-else>退回申請人重新編輯。</div>
                            </div>
                            <span slot="reference">
                                <el-button :disabled="hasDeclaredReceipts" @click="handleSelfReturnBtnClick">申請人自行退回</el-button>
                            </span>
                        </el-popover>
                    </template>
                    <template v-if="isShowRejectBtn">
                        <el-popover placement="top" width="250" :close-delay="0" trigger="hover">
                            <div style="padding: 10px">
                                <div style="font-size: 12pt; font-weight: bold; margin-bottom: 12px">退件</div>
                                <div v-if="hasDeclaredReceipts">
                                    <div>檢附單據中含有已申報的單據，無法退件。</div>
                                    <div style="margin-top: 12px">請聯繫營業稅申報人員做處理。</div>
                                </div>
                                <div v-else>退回申請人重新編輯。</div>
                            </div>
                            <template slot="reference">
                                <el-button type="danger" @click="handleRejectBtnClick" icon="el-icon-close" :disabled="hasDeclaredReceipts">退件</el-button>
                            </template>
                        </el-popover>
                    </template>
                    <el-button v-if="isShowApproveBtn" type="success" class="primary-action" @click="supApprovePayment" style="width: 150px" icon="el-icon-check" :loading="isSubmittingAgree"
                        >同意</el-button
                    >
                    <el-button v-if="isShowPaidBtn" type="success" class="primary-action" @click="handlePaidBtnClick" icon="el-icon-check">填寫付款明細</el-button>
                    <el-button v-if="isShowEditBtn" type="primary" class="primary-action" @click="handleEditBtnClick">編輯</el-button>
                    <el-button v-if="isShowPassBtn" type="success" @click="handlePassBtnClick" icon="el-icon-check" :loading="isSubmittingPass">確認付款</el-button>
                </div>
            </div>
        </div>
        <div id="payment-detail-bottom-scroll-anchor"></div>
        <ProjectDetailDialog ref="projectDetailDialog" :visible="projectDetailDialog.visible" @close="handleDetailDialogClose" :sno="projectDetailDialog.sno" />
        <PaymentCopyDialog ref="paymentCopyDialog" :payment="form" :visible="paymentCopyDialog.visible" @close="handleCopyDialogClose" />
        <ModifyRelatedProjectDialog ref="modifyProjectDialog" :sno="form.sno" :visible="modifyProjectDialog.visible" :current-poo="form.poo" :current-payment-typ="form.typ" @close="handleModifyProjectClose" @success="handleModifyProjectSuccess" />
    </el-dialog>
</template>
<script>
import _ from 'lodash';
import {
    paymentType, serviceTypeList, paymentPayToType, serviceType9AList, serviceType9BList,
} from '@/assets/commonData/options';
import ahAuditProgress from '@/components/ui/ahAuditProgress.vue';
import StateItemInlineEditor from '@/components/ui/StateItemInlineEditor_New.vue';
import ReceiptUploadInput from '@/components/ui/ReceiptUploadInput.vue';
import ahElSelectBankAccount from '@/components/ui/ahElSelectBankAccount.vue';
import ahProjectDetailView from '@/components/dashboard/Project/ahProjectDetailView.vue';
import ServiceFeeStatementDetailView from '@/components/dashboard/Project/ServiceFeeStatementDetailView.vue';
import PaymentPaid from './PaymentPaid.vue';
import PaymentReject from './PaymentReject.vue';
import PaymentStatusLabel from './PaymentStatusLabel.vue';

export default {
    name: 'PaymentDetailDialog',
    props: ['visible', 'sno'],
    components: {
        PaymentPaid,
        PaymentReject,
        PaymentStatusLabel,
        ahAuditProgress,
        StateItemInlineEditor,
        ReceiptUploadInput,
        ahElSelectBankAccount,
        ProjectDetailDialog: () => import('@/components/dashboard/Project/ProjectDetailDialog.vue'),
        PaymentCopyDialog: () => import('@/components/dashboard/Payment/PaymentCopyDialog.vue'),
        ModifyRelatedProjectDialog: () => import('@/components/dashboard/Payment/ModifyRelatedProjectDialog.vue'),
        ahProjectDetailView,
        ServiceFeeStatementDetailView,
        AccountingInfoBlock: () => import('@/components/ui/AccountingInfoBlock.vue'),
    },
    data() {
        return {
            isServiceFeeStatementSubmitted: false,
            isCheckSubmitted: false,
            isUploadFileSubmitted: false,
            isSubmittingPass: false,
            isSubmittingAgree: false,
            isAuditPassed: false,
            isSubmittingReceipt: false,
            isReceiptChanged: false,
            isStatementChanged: false,
            isSimpleInfoChanged: false,
            isToBeAddFileChanged: false,
            isEditingFinishedPayData: false,
            isEditingFinishedTaxData: false,
            isEditingFinishedGen2Data: false,
            isUpdatingFinishPayment: false,
            isPdatChanged: false,
            currTab: 'payment',
            paymentType,
            action: 'view', // view, reject, paid, upload-receipt
            showReturnDialog: false,
            form: {},
            payToList: null,
            projectList: null,
            invoiceType: null,
            bankAccountList: [],
            errorMsg: '',
            editPdatEnable: false,
            editPdatDate: new Date().getTime(),
            projectDetailDialog: {
                sno: null,
                visible: false,
            },
            paymentCopyDialog: {
                visible: false,
            },
            modifyProjectDialog: {
                visible: false,
            },
            simpleInfo: {
                nam: null,
                modifY_REASON: null,
                dat: null,
            },
            rules: {
                nam: [{ required: true, message: '請輸入摘要', trigger: 'blur' }],
                modifY_REASON: [{ required: true, message: '請輸入修改原因', trigger: 'blur' }],
                dat: [{ required: true, message: '請輸入請款單日期', trigger: 'change' }],
            },
            isLoading: false,
            isEditNamMode: false,
            isEditDateMode: false,
            expireTimeOption: {
                disabledDate(date) {
                    return date.getTime() >= Date.now();
                },
            },
            selectedProject: {
                name: null,
                payoutMax: null,
                payoutTotal: null,
                payoutBalance: null,
                projectEmployeePermissions: [],
            },
            isProjectFetchable: false,

            originalFiles: [],
        };
    },
    watch: {
        sno(newSno) {
            if (newSno) this.load(newSno);
        },
    },
    computed: {
        isProjectBudgetVisible() {
            return this.isAuth('C04') || this.isProjectFetchable;
        },
        isProjectOpenable() {
            const isPM = this.userSno === this.selectedProject.stF_SNO;
            const isOpenableEmployee = this.selectedProject.projectEmployeePermissions?.find((p) => p.employeeSno === this.userSno)?.viewProject;
            return this.isAuth('C04') || isPM || (this.isProjectFetchable && isOpenableEmployee);
        },
        isEditable() {
            if (this.form.deleted) return false;
            if (this.form.sigN_STS === 1) return this.isCreator;
            if (this.form.sigN_STS === 5) return this.isAuth('A02');
            if (this.form.sigN_STS === 2 || this.form.sigN_STS === 3) return this.isAuth('A03');

            return false;
        },
        taX_AMT_NTD() {
            if (this.form.cny !== 'TWD') {
                return this.form.taX_AMT * this.form.paY_CNYRAT;
            }
            return this.form.taX_AMT;
        },
        geN2_AMT_NTD() {
            if (this.form.cny !== 'TWD') {
                return this.form.geN2_AMT * this.form.paY_CNYRAT;
            }
            return this.form.geN2_AMT;
        },
        isTaxPayDateInvalid() {
            return this.form.taX_CHK && this.form.taX_PAY_DAT !== null && this.form.taX_PAY_DAT < this.form.paY_DAT;
        },

        isGen2PayDateInvalid() {
            return this.form.geN2_CHK && this.form.geN2_PAY_DAT !== null && this.form.geN2_PAY_DAT < this.form.paY_DAT;
        },

        userSno() {
            return this.$store.getters['account/userSno'];
        },
        isCreator() {
            return this.form.stF_SNO === this.userSno;
        },
        isAuthAllowPersonalInfoDisplay() {
            // 建立人
            if (this.isCreator) return true;

            // 有付款、確認付款權限
            if (this.isAuth('A02') || this.isAuth('A03')) return true;

            // 委外付款，且有「委外管理」權限
            if (this.form.paY_TO !== 1 && this.isAuth('C03')) return true;

            return false;
        },
        isAudited() {
            if (this.form.audits) {
                return this.form.audits.some((x) => x.fin === 1);
            }

            return false;
        },
        isShowPayEditBtn() {
            return (
                this.isAuth('A03') // 要有確認付款權限
                && (this.form.sigN_STS === 3 || this.form.sigN_STS === 2) // 請款單狀態為完成或待確認付款
                && this.form.voU_STS === 0
                && !this.form.deleted
            ); // 傳票狀態為待辦
        },
        isShowTaxEditBtn() {
            if (this.isAuth('A02') && this.form.sigN_STS === 2 && this.form.paY_DAT > new Date().getTime()) return !this.form.deleted;

            return (
                this.isAuth('A03') // 要有確認付款權限
                && this.form.sigN_STS === 3 // 請款單狀態為完成
                && this.form.voU_STS === 0
                && !this.form.deleted
            ); // 傳票狀態為待辦
        },
        isShowGen2EditBtn() {
            if (this.isAuth('A02') && this.form.sigN_STS === 2 && this.form.paY_DAT > new Date().getTime()) return !this.form.deleted;

            return (
                this.isAuth('A03') // 要有確認付款權限
                && this.form.sigN_STS === 3 // 請款單狀態為完成
                && this.form.voU_STS === 0
                && !this.form.deleted
            ); // 傳票狀態為待辦
        },
        filesTotalAmt() {
            let sum = 0;
            if (this.form.files) {
                for (let i = 0; i < this.form.files.length; i += 1) {
                    sum += this.form.files[i].amt;
                }
            }
            return sum;
        },
        nowAuditingIndex() {
            if (this.form.audits) {
                for (let i = 0; i < this.form.audits.length; i += 1) {
                    if (this.form.audits[i].fin === 3) {
                        return i;
                    }
                    if (this.form.audits[i].fin === 0) {
                        return i;
                    }
                }
            }
            return 0;
        },
        nowAuditingAudit() {
            return this.form.audits ? this.form.audits[this.nowAuditingIndex] : null;
        },
        isAuditor() {
            const currAudit = this.nowAuditingAudit;
            return _.find(currAudit?.auditors, ['sno', this.userSno]);
        },
        isCreatedToBePaid() {
            return this.form.paY_STF_SNO === this.userSno;
        },
        auditPass() {
            return this.form.audits.find((x) => x.menU_UNT === 'A03');
        },
        rejectAuditingAudit() {
            let rejectAuditIndex = -1;
            if (this.form.audits) {
                for (let i = 0; i < this.form.audits.length; i += 1) {
                    if (this.form.audits[i].fin === 3) {
                        rejectAuditIndex = i;
                    }
                }
            }
            if (rejectAuditIndex !== -1) {
                return this.form.audits[rejectAuditIndex];
            }
            return null;
        },
        getPayToName() {
            if (!this.form.sno) return '';
            if (this.payToList && this.form.vdR_SNO) {
                const to = this.payToList.find((x) => x.sno === this.form.vdR_SNO);
                if (to) return to.fnam;
            }

            return this.form.paY_NAM || `公司員工 - ${this.form.payName}`;
        },
        payToTitle() {
            const payToType = paymentPayToType.find((x) => x.key === this.form.paY_TO);
            if (payToType) {
                return payToType.label;
            }
            return '';
        },

        checkPassed() {
            if (this.form.audits && this.form.audits.find((x) => x.menU_UNT === 'A03' && x.fin === 1)) {
                return true;
            }

            return false;
        },
        checkAudited() {
            if (this.form.audits && this.form.audits.find((x) => x.menU_UNT === 'A02' && x.fin === 1)) {
                return true;
            }

            return false;
        },
        getAuditData() {
            if (this.form.audits) {
                return this.form.audits.find((x) => x.menU_UNT === 'A02');
            }

            return null;
        },

        returnHistories() {
            if (this.form.audits) {
                const returns = [];
                for (let i = 0; i < this.form.audits.length; i += 1) {
                    if (this.form.audits[i].rsn && this.form.audits[i].rsn !== '') {
                        returns.push({
                            rsn: this.form.audits[i].rsn,
                            stF_NAM: this.form.audits[i].stF_NAM,
                            rolE_TYP: this.form.audits[i].rolE_TYP,
                            sno: this.form.audits[i].sno,
                        });
                    }
                }
                return returns;
            }
            return [];
        },

        /*
            sigN_STS:
            1 = 待（主管、指定人、PM）審核
            5 = 待付款(A02)
            2 = 待確認付款(A03)
            3 = 完成
            4 = 退件
        */

        // 作廢按鈕
        isShowDeleteBtn() {
            // 若已作廢則不顯示
            if (this.form.deleted) return false;

            // 若申請人被停用，一律顯示作廢按鈕
            if (!this.form.creatorOnf) return true;

            // 未完成，使用者有單據審核權限
            if (this.form.sigN_STS === 1 || this.form.sigN_STS === 5 || this.form.sigN_STS === 2) {
                const currAudit = this.nowAuditingAudit;
                // 是申請人
                if (currAudit && this.isCreator) return true;

                // 是當前審核人
                if (this.isAuditor) return true;

                // 有 A02, A03
                if (this.isAuth('A02') || this.isAuth('A03')) return true;
            } else if (this.form.sigN_STS === 3) {
                // 完成後
                // 有 A03 (2024-10-28 討論)
                if (this.isAuth('A03')) return true;
            } else if (this.form.sigN_STS === 4) {
                // 退件
                // 使用者為申請人 或 有 A02, A03
                if (this.form.stF_SNO === this.userSno || this.isAuth('A02') || this.isAuth('A03')) {
                    return true;
                }
                return false;
            }
            return false;
        },

        // 退回按鈕
        isShowRejectBtn() {
            if (this.form.sigN_STS === 1 || this.form.sigN_STS === 5 || this.form.sigN_STS === 2) {
                if (this.isAuditor) return true;
            }
            return false;
        },

        // 申請人取回按鈕
        isShowSelfReturnBtn() {
            if ((this.form.sigN_STS === 1 || this.form.sigN_STS === 5) && this.isCreator) {
                // 與審核人重複則不顯示
                if (this.isAuditor) return false;

                return true;
            }
            return false;
        },

        // 主管同意按鈕
        isShowApproveBtn() {
            if (this.form.sigN_STS === 1) {
                if (this.isAuditor) return true;
            }
            return false;
        },
        // 付款按鈕
        isShowPaidBtn() {
            if (this.form.sigN_STS === 5) {
                if (this.isAuditor) return true;
            }
            return false;
        },

        // 確認付款按鈕
        isShowPassBtn() {
            if (this.form.sigN_STS === 2) {
                if (this.nowAuditingAudit?.menU_UNT === 'A03') {
                    if (this.isAuditor) return true;
                }
            }
            return false;
        },
        // 列印請款單按鈕
        isShowPrintBtn() {
            return true;

            // if (this.form.sigN_STS >= 2 && this.form.sigN_STS != 4) {
            // return true;
            // } else {
            // return false;
            // }
        },
        // 編輯按鈕
        isShowEditBtn() {
            // 有"申請請款單(A01)"權限
            if (!this.isAuth('A01')) return false;

            // 請款單狀態為“退件”
            if (this.form.sigN_STS === 4) {
                return this.form.stF_SNO === this.userSno;
            }
            return false;
        },
        // 單據編輯按鈕
        isShowReceiptEditBtn() {
            if (this.isCreator || this.isAuthOne(['A02', 'A03'])) {
                return !this.form.deleted;
            }
            return false;
        },
        // 會計傳票資訊
        isAccountingVoucherDetailShow() {
            return !this.form.deleted && (this.form.sigN_STS === 2 || this.form.sigN_STS === 3);
        },
        hasDeclaredReceipts() {
            if (this.form && this.form.files) {
                if (this.form.files.find((f) => f.declareStatus === 1)) {
                    return true;
                }
            }
            return false;
        },

        // 是否已暫存付款明細
        isTempSaved() {
            return this.form.sigN_STS === 5 && this.form.a02_ISTEMP;
        },
        // 支出項目顯示條件
        isStateItemInlineEditorShow() {
            return (!this.form.deleted && (this.form.sigN_STS === 2 || this.form.sigN_STS === 3)) || this.isTempSaved;
        },
        // 變更所屬專案按鈕 disable 訊息
        modifyProjectDisableMsg() {
            // 請款單狀態需為待確認付款(sigN_STS = 2)或完成(sigN_STS = 3)
            if (this.form.sigN_STS !== 2 && this.form.sigN_STS !== 3) {
                return '請款單狀態需為待確認付款或完成';
            }
            // 使用者需有專案總管理權限(C04)
            if (!this.isAuth('C04')) {
                return '您沒有專案總管理權限';
            }
            // 請款單類型需為一般請款、專案請款、特別費用請款
            if (this.form.typ !== 1 && this.form.typ !== 2 && this.form.typ !== 3) {
                return '請款單類型需為一般請款、專案請款、特別費用請款';
            }
            return '';
        },
    },
    created() {
        this.fetchBankAccountData();
    },
    destroyed() {
        document.body.classList.remove('detail-opened');
    },
    methods: {
        onInitSimpleInfo() {
            this.simpleInfo = {
                nam: this.form.nam,
                dat: this.form.dat,
                modifY_REASON: this.form.naM_MODIFY_REASON,
            };
        },
        onEditNam() {
            this.isEditNamMode = true;
        },
        onEndEditNam() {
            this.isEditNamMode = false;
            this.onInitSimpleInfo();
        },
        onEditDate() {
            this.isEditDateMode = true;
        },
        onEndEditDate() {
            this.isEditDateMode = false;
            this.onInitSimpleInfo();
        },
        onSubmitModifyNam() {
            if (this.simpleInfo.nam === this.form.nam && this.simpleInfo.modifY_REASON === this.form.naM_MODIFY_REASON) {
                this.isEditNamMode = false;
                return;
            }

            this.$refs.form.validate(async (valid) => {
                if (valid) {
                    try {
                        this.isLoading = true;

                        await this.$api({
                            url: '/PaymentManagenmentPage/ModifyNam',
                            method: 'POST',
                            data: {
                                sno: this.form.sno,
                                nam: this.simpleInfo.nam,
                                modifY_REASON: this.simpleInfo.modifY_REASON,
                            },
                        });

                        this.reload();
                        this.isSimpleInfoChanged = true;
                        this.isEditNamMode = false;
                    } finally {
                        this.isLoading = false;
                    }
                }
            });
        },
        onSubmitModifyDate() {
            if (this.simpleInfo.dat === this.form.dat) {
                this.isEditDateMode = false;
                return;
            }

            this.$refs.form.validate(async (valid) => {
                if (valid) {
                    try {
                        this.isLoading = true;

                        await this.$api({
                            url: '/PaymentManagenmentPage/ModifyPayDateInfo',
                            method: 'POST',
                            data: {
                                sno: this.form.sno,
                                dat: this.simpleInfo.dat,
                            },
                        });

                        this.reload();
                        this.isSimpleInfoChanged = true;
                        this.isEditDateMode = false;
                    } finally {
                        this.isLoading = false;
                    }
                }
            });
        },
        load(sno) {
            this.fetchDetailData(sno);
            this.action = 'view';
            this.currTab = 'payment';
        },
        reload() {
            this.action = 'view';
            this.currTab = 'payment';
            this.isEditingFinishedPayData = false;
            this.isEditingFinishedTaxData = false;
            this.isEditingFinishedGen2Data = false;
            return this.fetchDetailData(this.form.sno);
        },
        emptyData() {
            this.action = 'view';
            this.isServiceFeeStatementSubmitted = false;
            this.isCheckSubmitted = false;
            this.isUploadFileSubmitted = false;
            this.isSubmittingPass = false;
            this.isPdatChanged = false;
            this.isSubmittingAgree = false;
            this.isAuditPassed = false;
            this.isUploadFileSubmitted = false;
            this.isReceiptChanged = false;
            this.isPayDataChanged = false;
            this.isEditingFinishedPayData = false;
            this.isEditingFinishedTaxData = false;
            this.isEditingFinishedGen2Data = false;
            this.form = {};
            this.isEditNamMode = false;
            this.isEditDateMode = false;
            this.simpleInfo = { nam: null, modifY_REASON: null, dat: null };

            this.isCheckSubmitted = false;
            this.isUploadFileSubmitted = false;
            this.isSubmittingPass = false;
            this.isSubmittingAgree = false;
            this.isStatementChanged = false;
            this.isSimpleInfoChanged = false;
            this.isToBeAddFileChanged = false;
            this.isPayDataChanged = false;
            this.selectedProject = {
                name: null,
                payoutMax: null,
                payoutTotal: null,
                payoutBalance: null,
            };
        },
        goBackToList() {
            this.$router.push({ name: 'payment' });
        },
        openProjectDetail(sno) {
            if (!this.isProjectOpenable) return;
            this.projectDetailDialog.sno = sno;
            this.projectDetailDialog.visible = true;
        },
        fetchDetailData(sno) {
            if (sno) {
                const loadingTarget = this.$refs.paymentDetailDialig.$el.querySelector('.el-dialog');
                const loading = this.$loading({
                    lock: true,
                    text: '載入中',
                    spinner: 'el-icon-loading',
                    target: loadingTarget,
                });

                return this.$api({
                    url: `/PaymentManagenmentPage/GetPaymentInfo?Sno=${sno}`,
                    method: 'GET',
                })
                    .then(async (resp) => {
                        console.log('api payemt', resp);
                        this.form = resp.data.item;
                        this.fetchOtherLists();
                        this.onInitSimpleInfo();
                        await this.fetchProjectDetail(resp.data.item.projectSNO);
                        console.log('Payment Detail: ', this.form);

                        this.originalFiles = _.cloneDeep(this.form.files);
                    })
                    .finally(() => {
                        loading.close();
                    });
            }
            return null;
        },
        async fetchProjectDetail(sno) {
            if (!sno) return;
            console.log('fetch Project Detail!!!');

            try {
                const resp = await this.$api_silent({
                    url: '/PaymentManagenmentPage/GetProjectDetail',
                    params: { sno },
                    method: 'GET',
                });
                const isTyp2 = resp.data.item.poo.includes('PJ');

                const projectPreOut = this.form.typ === 2 || (this.form.typ === 6 && isTyp2) ? resp.data.item.amT_PREOUT : resp.data.item.amt;
                // 支出總額
                const payoutTotal = _.chain(resp.data.item.payouts)
                    .filter((o) => o.sigN_STS === 2 || o.sigN_STS === 3)
                    .sumBy((o) => o.amt * o.paY_CNYRAT)
                    .value();

                // 餘額
                const payoutBalance = projectPreOut && projectPreOut - payoutTotal;

                this.selectedProject = {
                    name: resp.data.item.nam,
                    payoutMax: projectPreOut,
                    payoutTotal,
                    payoutBalance,
                    payouts: resp.data.item.payouts,
                    cny: resp.data.item.cny,
                    stF_SNO: resp.data.item.stF_SNO,
                    projectAuditor: resp.data.item.projectAuditor,
                    projectEmployeePermissions: resp.data.item.projectEmployeePermissions,
                    isTyp2,
                };
                this.isProjectFetchable = true;
            } catch (e) {
                if (e.respponse?.data === '權限不足') this.isProjectFetchable = false;
                console.error('fetch project detail error', e.response.data);
            }
        },
        // 關閉視窗
        handleBeforeClose(done) {
            // 正在編輯狀態，彈出是否關閉（防止編輯中誤觸而資料消失）
            if (this.action !== 'view') {
                this.$confirm('您正在編輯，確認要關閉請款單？', {
                    confirmButtonText: '確定',
                    cancelButtonText: '取消',
                })
                    .then(() => {
                        done();
                        this.$emit('close', true);
                        this.emptyData(); // 為了下次開啟不顯示之前的資料
                    })
                    .catch(() => {});
            }

            // 瀏覽狀態，隨時可以關閉
            if (this.action === 'view') {
                // 剛才行政審核過, 回表格要重新載入
                if (
                    this.isServiceFeeStatementSubmitted
                    || this.isCheckSubmitted
                    || this.isUploadFileSubmitted
                    || this.isReceiptChanged
                    || this.isStatementChanged
                    || this.isPdatChanged
                    || this.isToBeAddFileChanged
                    || this.isAuditPassed
                    || this.isSimpleInfoChanged
                    || this.isPayDataChanged
                ) {
                    this.$emit('close', true);
                } else this.$emit('close');

                this.emptyData(); // 為了下次開啟不顯示之前的資料
            }
        },
        // 按下編輯
        handleEditBtnClick() {
            if (this.form.tranServiceFeeStatement) {
                this.$router.push({
                    name: 'edit-transform-service-fee-statement',
                    params: { sno: this.form.sno },
                    query: { from: 'payment' },
                });
            } else {
                this.$router.push({
                    name: 'payment-edit',
                    params: { sno: this.form.sno },
                });
            }
        },
        // 按下退件
        handleRejectBtnClick() {
            this.action = 'reject';
            this.scrollToId('payment-detail-reject-anchor');
        },
        // 退件取消後
        handleRejectCanceled() {
            this.action = 'view';
        },
        // 申請人自行退回
        handleSelfReturnBtnClick() {
            this.$confirm('確定要自行退回該請款單？', {
                confirmButtonText: '確定',
                cancelButtonText: '取消',
            })
                .then(() => {
                    const form = {
                        sno: this.form.sno,
                        isTakeBack: true,
                        audit: {
                            fin: 3,
                            rsn: '申請人自行退回',
                            menU_UNT: this.nowAuditingAudit.menU_UNT,
                        },
                    };
                    this.$api({
                        url: '/PaymentManagenmentPage/AuditPayment',
                        method: 'post',
                        data: form,
                    })
                        .then(() => {
                            this.$emit('close', true);
                            this.emptyData(); // 為了下次開啟不顯示之前的資料
                        })
                        .catch((e) => {
                            console.log(e);
                            this.reload();
                            this.isAuditPassed = true;
                        })
                        .finally(() => {});
                })
                .catch(() => {});
        },
        // 退件送出後
        handleRejectSubmitted() {
            this.$emit('close', true);
        },
        // 按下付款
        handlePaidBtnClick() {
            this.action = 'paid';

            // scrollToBottom
            // el-dialog__wrapper payment-detail-dialog ah-detail-dialog

            // console.log(this.$refs.paymentDetailDialig.$el)
            // console.log("scrollTop", this.$refs.paymentDetailDialig.$el.scrollTop)
            // console.log("clientHeight", this.$refs.paymentDetailDialig.$el.clientHeight)
            // console.log("scrollHeight", this.$refs.paymentDetailDialig.$el.scrollHeight)
            // setTimeout(() => {
            // this.scrollToBottom(this.$refs.paymentDetailDialig.$el)
            // }, 1);
            // console.log("AFDFSD")
            this.$nextTick(() => {
                this.$refs.paymentPaid.initAuSuggestAccountingItemsSelector();
            });
            this.scrollToId('payment-detail-check-auto-scroll-anchor');
        },
        handlePaidCanceled() {
            this.action = 'view';
        },
        handlePaidSubmitted() {
            this.isCheckSubmitted = true;
            this.reload().then(() => {
                this.scrollToId('payment-detail-bottom-scroll-anchor');
            });
        },
        handlePaidSave() {
            this.isCheckSubmitted = true;
            this.reload().then(() => {
                this.scrollToId('payment-detail-bottom-scroll-anchor');
            });
        },
        handleUploadFileSubmitted() {
            this.reload();
            this.isUploadFileSubmitted = true;
            setTimeout(() => {
                this.currTab = 'attachment';
            }, 200);
        },
        handleEditPdatBtnClick() {
            this.editPdatEnable = true;
            this.editPdatDate = this.form.pdat;
            setTimeout(() => {
                this.$refs.editPdatDatePicker.focus();
            }, 50);
        },
        handleEditPdatCancelBtnClick() {
            this.editPdatEnable = false;
        },
        getCnyRat(cny) {
            const cnyOption = this.$store.getters['cny/cnyOptions'].find((x) => x.cny === cny);
            if (cnyOption) return cnyOption.rat;
            return 1;
        },
        handleEditPdatSubmitBtnClick() {
            if (this.editPdatDate === this.form.pdat) {
                this.editPdatEnable = false;
                return;
            }

            this.$api({
                url: '/PaymentManagenmentPage/UpsertPaymentPdat',
                method: 'POST',
                data: {
                    sno: this.form.sno,
                    pdat: this.editPdatDate,
                },
            })
                .then(() => {
                    this.isPdatChanged = true;
                    this.$message({
                        showClose: true,
                        message: '預計付款日已修改。',
                        type: 'success',
                    });
                })
                .finally(() => {
                    this.reload();
                    this.editPdatEnable = false;
                });
        },
        handleAddReceiptClick() {
            if (this.$refs.receiptUploadInput) {
                this.$refs.receiptUploadInput.handleUploadBtnClick();
            }
        },
        handleCancelReceiptBtnClick() {
            this.action = 'view';
            this.isUploadFileSubmitted = true;
            this.reload();
        },
        async onReceiptUploadInputSave() {
            const actionBeforeSave = this.action;
            try {
                const files = this.form.files.map((item) => {
                    const RET = { ...item };
                    if (![1, 2, 3, 10, 11].includes(item.filE_TYP)) {
                        RET.foo = '';
                        RET.tax = 0;
                    }
                    if (![1, 2, 3, 4, 10, 11].includes(item.filE_TYP)) RET.bsn = '';
                    return RET;
                });

                await this.$api({
                    url: '/PaymentManagenmentPage/UpdateReciptFile',
                    method: 'POST',
                    data: {
                        payoo: this.form.payoo,
                        toBeAddFile: this.form.toBeAddFile,
                        files,
                    },
                });
                this.reload();
                this.action = actionBeforeSave;
                this.isToBeAddFileChanged = true;
            } catch (e) {
                console.log(e);
                this.form.files = this.originalFiles;
                this.originalFiles = _.cloneDeep(this.form.files);
            }
        },
        getPaymentType(type) {
            if (this.paymentType && type) {
                const py = this.paymentType.find((x) => x.key === type);
                if (py) return py.value;
            }
            return '';
        },
        getFileType(type) {
            if (this.invoiceType && type) {
                const iy = this.invoiceType.find((x) => x.key === type);
                if (iy) return iy.value;
            }

            return null;
        },
        fetchOtherLists() {
            this.$api({
                url: '/PaymentManagenmentPage/GetAttachTypeOption',
                method: 'GET',
            }).then((resp) => {
                this.invoiceType = resp.data.items;
            });
            if (this.form.paY_TO === 2) {
                // 現有廠商清單
                this.$api({
                    url: '/Outsourcing/GetOutsourcingList?VDR_TYP=VD&PageSize=999&PageNum=1',
                    method: 'GET',
                }).then((resp) => {
                    this.payToList = resp.data.items;
                });
            } else if (this.form.paY_TO === 3) {
                // 現有外包清單
                this.$api({
                    url: '/Outsourcing/GetOutsourcingList?VDR_TYP=OS&PageSize=999&PageNum=1',
                    method: 'GET',
                }).then((resp) => {
                    this.payToList = resp.data.items;
                });
            }
        },
        fetchBankAccountData() {
            // 經常性費用
            this.$api({
                url: '/Tool/GetBankAccountOptions',
                method: 'GET',
            }).then((resp) => {
                this.bankAccountList = resp.data.options;
            });
        },
        deletePayment() {
            if (confirm('確定要作廢該請款單？')) {
                this.$api({
                    url: '/PaymentManagenmentPage/DeletePaymentInfo',
                    method: 'DELETE',
                    data: { sno: this.form.sno },
                }).then(() => {
                    this.$emit('close', true);
                });
            }
        },
        printPayment() {
            this.$router.push({
                name: 'payment-pdf',
                params: { sno: this.form.sno },
            });
        },
        // 主管＆指定審核人同意
        supApprovePayment() {
            this.isSubmittingAgree = true;

            const approveData = {
                sno: this.form.sno,
                paY_DAT: null,
                paY_WAY: null,
                paY_BNK_SNO: null,
                iteM_SNO: null,
                geN2_PAY_DAT: null,
                taX_PAY_DAT: null,
                audit: {
                    sno: this.nowAuditingAudit.sno,
                    sot: this.nowAuditingAudit.sot,
                    fin: 1,
                    rsn: null,
                    menU_UNT: this.nowAuditingAudit.menU_UNT,
                },
            };

            this.$api({
                url: '/PaymentManagenmentPage/AuditPayment',
                method: 'post',
                data: approveData,
            })
                .then(() => {
                    this.$emit('close', true);
                    this.$message({
                        showClose: true,
                        message: '請款審核通過！',
                        type: 'success',
                    });
                })
                .catch((e) => {
                    console.log(e);
                    this.reload();
                    this.isAuditPassed = true;
                })
                .finally(() => {
                    this.isSubmittingAgree = false;
                });
        },

        // 確認付款
        handlePassBtnClick() {
            if (this.form.paY_DAT > new Date().getTime()) {
                this.$message({
                    showClose: true,
                    message: '不可確認未來付款，請於實際付款日期後再做確認。',
                    type: 'error',
                });
                return;
            }

            this.$confirm('已核對且確認此筆付款資訊無誤？（確認後將無法修改）', {
                confirmButtonText: '確定',
                cancelButtonText: '取消',
            })
                .then(() => {
                    this.passPayment();
                })
                .catch(() => {});
        },
        passPayment() {
            this.isSubmittingPass = true;

            console.log(this.form);
            this.form.audit = {
                fin: 1,
                rsn: null,
                menU_UNT: this.nowAuditingAudit.menU_UNT,
            };

            this.$api({
                url: '/PaymentManagenmentPage/AuditPayment',
                method: 'post',
                data: this.form,
            })
                .then(() => {
                    this.isCheckSubmitted = true;
                    this.$message({
                        showClose: true,
                        message: '請款單已完成！',
                        type: 'success',
                    });
                    this.reload().then(() => {
                        this.scrollToId('payment-detail-bottom-scroll-anchor');
                    });
                })
                .catch((e) => {
                    console.log(e);
                    this.reload();
                    this.isAuditPassed = true;
                })
                .finally(() => {
                    this.isSubmittingPass = false;
                });

            /*
            this.$api({
                url: "PaymentManagenmentPage/BulkAuditPayment",
                method: "POST",
                data: { snos: [this.form.sno] },
            }).then(() => {
                this.isCheckSubmitted = true;
                this.$message({
                    showClose: true,
                    message: '請款單已完成！,
                    type: 'success'
                });
                this.reload().then(() => {
                    this.scrollToId("payment-detail-bottom-scroll-anchor")
                });
            }).finally(() => {
                this.isSubmittingPass = false
            });
            */
        },
        handleCancelClick() {
            this.$confirm('確認要作廢請款單？（作廢後不可恢復）', {
                confirmButtonText: '確定',
                cancelButtonText: '取消',
            })
                .then(() => {
                    this.submitCancel();
                })
                .catch(() => {});
        },
        submitCancel() {
            this.$api({
                url: 'PaymentManagenmentPage/DeletePaymentInfo',
                method: 'DELETE',
                data: { sno: this.form.sno },
            })
                .then(() => {
                    this.$emit('close', true);
                    this.$message({
                        showClose: true,
                        message: '請款單已作廢',
                        type: 'success',
                    });
                })
                .finally(() => {
                    this.isSubmittingPass = false;
                });
        },
        openAttFile() {
            window.open(this.form.filE_ATT);
        },
        openAgreeFile() {
            window.open(this.form.FILE_AGREE);
        },
        getBankAccountNameBySno(sno) {
            if (sno === null || sno < 0) return '零用現金付款';

            const bankAccount = this.bankAccountList.find((item) => item.sno === sno);
            if (bankAccount) {
                return bankAccount.tpc;
            }

            return '---';
        },
        handleDetailDialogClose() {
            this.projectDetailDialog.visible = false;
            this.projectDetailDialog.sno = null;
        },
        handleCopyDialogClose() {
            this.paymentCopyDialog.visible = false;
        },
        async submitPayChange() {
            try {
                // 檢查代扣所得稅日期不早於付款日期
                if (
                    (this.form.taX_AMT || this.form.geN2_AMT)
                    && (this.form.sigN_STS === 2 || this.form.sigN_STS === 3 || (this.form.sigN_STS == 5 && this.form.a02_ISTEMP))
                    && (this.isTaxPayDateInvalid || this.isGen2PayDateInvalid)
                ) {
                    this.$message({
                        showClose: true,
                        message: '代扣所得稅、代扣二代健保繳款日應於實際付款日之後',
                        type: 'error',
                    });
                    return;
                }

                this.isUpdatingFinishPayment = true;

                await this.$api({
                    url: '/PaymentManagenmentPage/UpdateFinishPayment',
                    method: 'post',
                    data: {
                        sno: this.form.sno,
                        paY_WAY: this.form.paY_WAY,
                        paY_DAT: this.form.paY_DAT,
                        paY_BNK_SNO: this.form.paY_BNK_SNO,
                        taX_BNK_SNO: this.form.taX_BNK_SNO === -1 ? null : this.form.taX_BNK_SNO,
                        taX_PAY_WAY: this.form.taX_BNK_SNO === -1 ? 1 : 2,
                        taX_PAY_DAT: this.form.taX_PAY_DAT,
                        geN2_BNK_SNO: this.form.geN2_BNK_SNO === -1 ? null : this.form.geN2_BNK_SNO,
                        geN2_PAY_WAY: this.form.geN2_BNK_SNO === -1 ? 1 : 2,
                        geN2_PAY_DAT: this.form.geN2_PAY_DAT,
                        iteM_SNO: this.form.iteM_SNO,
                    },
                });

                this.isUpdatingFinishPayment = false;

                this.$message({
                    showClose: true,
                    message: '修改已儲存。',
                    type: 'success',
                });
                this.reload();
            } catch (e) {
                console.log(e);
            }
            this.isPayDataChanged = true;
        },
        async onDeclareStatusChange({ receiptSno, declareStatus }) {
            console.log('receiptSno', receiptSno);
            console.log('declareStatus', declareStatus);
            await this.$api({
                url: '/PaymentManagenmentPage/Update401DeclareStatus',
                method: 'POST',
                data: {
                    sno: receiptSno,
                    declareStatus,
                },
            });

            this.fetchDetailData(this.form.sno);
        },

        // 個資保護
        protectedName(text) {
            if (this.isAuthAllowPersonalInfoDisplay || this.isCreatedToBePaid) return text;
            return this.protectedInfo(text, 'get', 1);
        },

        protectedNumber(text) {
            if (this.isAuthAllowPersonalInfoDisplay || this.isCreatedToBePaid) return text;
            return this.protectedInfo(text, 'cover', 4, true);
        },

        protectedEmail(text) {
            if (this.isAuthAllowPersonalInfoDisplay || this.isCreatedToBePaid) return text;
            return this.protectedInfo(text, 'split-@');
        },

        getServiceTypeTxt(serviceTypeNum) {
            const s = serviceTypeList.find((x) => x.value === serviceTypeNum);
            if (s) return s.label;
            return '';
        },
        getServiceSubTypeTxt(serviceSubType) {
            const s = [...serviceType9AList, ...serviceType9BList].find((x) => x.key === serviceSubType);
            console.log(s);
            if (s) return s.label;
            return '';
        },
        onMoreDropdownClick(command) {
            if (command === 'edit-nam') {
                this.onEditNam();
            } else if (command === 'duplicate') {
                // 複製請款單，有單據時出現單據勾選視窗，無單據直接複製。
                if (this.form && this.form.files && this.form.files.length > 0) {
                    this.paymentCopyDialog.visible = true;
                } else {
                    this.duplicate();
                }
            } else if (command === 'modifyProject') {
                this.modifyProjectDialog.visible = true;
            }
        },
        handleModifyProjectClose() {
            this.modifyProjectDialog.visible = false;
        },
        handleModifyProjectSuccess() {
            this.modifyProjectDialog.visible = false;
            this.reload();
        },
        duplicate() {
            this.$router.push({ name: 'payment-add', query: { copyfrom: this.form.sno } });
        },
        onEditFinishedTaxData() {
            this.isEditingFinishedTaxData = true;
            this.setupEditFinishForm();
        },
        onEditFinishedGen2Data() {
            this.isEditingFinishedGen2Data = true;
            this.setupEditFinishForm();
        },
        onEditingFinishedPayData() {
            this.isEditingFinishedPayData = true;
            this.setupEditFinishForm();
        },
        setupEditFinishForm() {
            this.form.taX_BNK_SNO = this.form.taX_BNK_SNO === null ? -1 : this.form.taX_BNK_SNO;
            this.form.geN2_BNK_SNO = this.form.geN2_BNK_SNO === null ? -1 : this.form.geN2_BNK_SNO;
        },

        // 勞報單事件
        onServiceFeeStatementSubmit() {
            this.isServiceFeeStatementSubmitted = true;
            this.reload();
        },
    },
};
</script>
<style lang="scss">
@import "@/assets/scss/vars.scss";
.payment-detail-dialog .edit-form {
    flex: 1;
    display: flex;
    align-items: center;
    flex-direction: column;
    > * {
        width: 100%;
    }
}
.payment-detail-dialog.ah-detail-dialog {
    @media print {
        position: relative;
    }

    /* aaaa */
    .el-dialog {
        margin-top: 6vh;
        background-color: #f6f6f6;
    }

    .nam-edit-input {
        font-size: 14pt;
        font-weight: 900;

        .el-input__inner {
            height: 40px;
            line-height: 40px;
        }
    }

    .info-amts {
        margin-top: 40px;
        margin-right: 0;

        @media (min-width: 992px) {
            margin-top: 0px;
            margin-right: 50px;
        }
    }

    .cny {
        font-size: 9pt;
        opacity: 0.7;
        margin: 0 0 0 10px;
    }

    .payment-type {
        display: inline-block;

        .type-label {
            color: $main-color;
            font-weight: bold;
        }

        &.project {
            // border: 1px solid #e8e8e8;

            .type-label {
                border-top-right-radius: 0;
                border-bottom-right-radius: 0;
            }
        }

        .project-label {
            display: inline-block;
            padding: 0px 10px;
            line-height: 30px;
            color: #555;
            font-size: 10pt;
            vertical-align: top;
            border-top-right-radius: 6px;
            border-bottom-right-radius: 6px;

            .type {
                display: inline-block;
                color: #666;
                background-color: #eee;
                margin-right: 8px;
                line-height: 20px;
                padding: 0 8px;
                font-size: 9pt;
                border-radius: 8px;
            }

            .sn {
                display: none;
            }

            .name {
                &.clickable {
                    cursor: pointer;

                    &:hover {
                        color: $main-color;
                    }
                }
            }
        }
    }

    .dialog-section {
        // border-top: 1px solid #eee;
        padding: 20px 30px;
        background-color: #fff;
        margin: 10px 10px;
        border-radius: 0px;
        border-left: 4px solid transparent;

        @media (max-width: 720px) {
            padding: 20px 13px;
        }

        > .dialog-section-title {
            display: table;
            width: 100%;
            margin: 0px 0 20px 0;
            font-size: 12pt;
            font-weight: 600;
            color: $main-color;

            > .left-cell {
                display: table-cell;
                vertical-align: top;
            }

            > .right-cell {
                display: table-cell;
                vertical-align: top;
                text-align: right;
            }
        }

        &.paid {
            background-color: #fffdf6;
            border-color: #f18d13;

            .dialog-section-title {
                color: #f18d13;

                .edit-btn {
                    color: #f18d13;
                }
            }
        }

        &.checked {
            background-color: #f7fff3;
            border-color: #0baa1b;

            .dialog-section-title {
                color: #0baa1b;
            }
        }

        &.reject {
            border-color: red;
            background-color: #fff7f7;

            .dialog-section-title {
                color: red;
            }
        }

        &.cancel {
            background-color: #e4e4e4;

            .dialog-section-title {
                color: #666;
            }
        }

        .edit-btn {
            margin-left: 10px;
            padding: 5px 10px;

            &.orange {
                border-color: #f18d1366;

                &:hover {
                    background-color: #f18d13;
                    color: #fff;
                }
            }
        }
    }

    .detail-row.footer {
        border-top: 0;
        background-color: unset;
    }

    .date-warning {
        font-size: 9pt;
        color: rgb(255, 119, 0);
    }

    .nam-block {
        display: flex;
        justify-content: space-between;
    }
    .pay-way-change-hint {
        font-size: 9pt;
        color: rgb(130, 130, 130);
    }

    .footer-action-buttons {
        display: flex;
        flex-direction: column;
        gap: 10px;

        @media (min-width: 768px) {
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
        }

        > .left {
            display: flex;
            flex-direction: row;
            gap: 10px;
        }

        > .right {
            display: flex;
            flex-direction: column;
            gap: 10px;

            .el-button {
                width: 100%;
                min-height: 50px;
            }

            @media (min-width: 768px) {
                flex-direction: row;

                .el-button {
                    min-height: unset;
                }
            }
        }
        .el-button + .el-button {
            margin-left: 0 !important;
        }
    }
    .edit-dat-set {
        display: flex;
        align-items: start;
        gap: 10px;

        > .actions {
            display: flex;
            align-items: center;
            gap: 5px;
        }
        .el-button {
            height: 32px;
        }

        .el-button + .el-button {
            margin-left: 0;
        }
    }
    .pay-to-type-label {
        display: inline-block;
        font-size: 9pt;
        font-weight: normal;
        opacity: 0.5;
        border: 1px solid #999;
        padding: 0px 5px;
        border-radius: 5px;
        margin-right: 8px;
    }
}
</style>

<style lang="scss" scoped></style>
